// @ts-nocheck
(function () {
  if (window.__MIXED_OFFER_INIT__) return; // voorkom dubbele init
  window.__MIXED_OFFER_INIT__ = true;
  
  var isApplying = false;
  var lastHash = "";
  var debounce = function (fn, ms) {
    var t;
    return function () {
      var args = arguments;
      clearTimeout(t);
      t = setTimeout(function () {
        fn.apply(null, args);
      }, ms);
    };
  };

  // Injecteer CSS fallback om quantity-selector in gelockte cross-sell rijen te blokkeren
  (function injectMixedOfferStyle(){
    try {
      if (document.getElementById('mixed-offer-style')) return;
      var style = document.createElement('style');
      style.id = 'mixed-offer-style';
      style.textContent = '.cart-items__table-row[data-cross-sell-lock="true"] .quantity-selector{opacity:.4;pointer-events:none}';
      document.head.appendChild(style);
    } catch(e) {}
  })();

  function getCart() {
    return fetch('/cart.js', { credentials: 'same-origin' }).then(function (r) { return r.json(); });
  }

  function compute(items) {
    var url = '/apps/cross-sell/compute';
    return fetch(url, {
      method: 'POST',
      headers: { 'content-type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify({ items: items, source: 'theme' })
    }).then(function (r) { return r.ok ? r.json() : { updates: [], messages: [] }; });
  }

  function itemsForCompute(cart) {
    return cart.items.map(function (i) {
      return {
        productId: i.product_id,
        variantId: i.variant_id,
        quantity: i.quantity,
        properties: i.properties || null
      };
    });
  }

  function variantToLines(cart) {
    var map = Object.create(null);
    cart.items.forEach(function (i) {
      var arr = map[i.variant_id] || [];
      arr.push({ key: i.key, qty: i.quantity });
      map[i.variant_id] = arr;
    });
    return map;
  }

  function planToLineUpdates(cart, plan) {
    var v2l = variantToLines(cart);
    var updates = [];

    (plan.updates || []).forEach(function (u) {
      var variantId = String(u.variantId);
      var desired = Math.max(0, parseInt(u.desiredQuantity, 10) || 0);
      var lines = v2l[variantId] || [];
      var current = lines.reduce(function (s, l) { return s + l.qty; }, 0);
      if (current === desired) return;

      var remaining = desired;
      // Stel bestaande lines in eerste instantie omlaag/omhoog naar remaining, rest wordt add
      for (var idx = 0; idx < lines.length; idx++) {
        var line = lines[idx];
        var newQty = Math.min(line.qty, remaining);
        updates.push({ type: 'line', key: line.key, qty: newQty, prevQty: line.qty });
        remaining -= newQty;
      }

      // Toevoegen als de variant al in de cart zit (qty-sync) OF als het een auto-add cadeau is
      // (mag uit het niets toegevoegd worden). Optionele cross-sells worden niet auto-geadd.
      if (remaining > 0 && (lines.length > 0 || u.allowAutoAdd)) {
        updates.push({ type: 'add', variantId: variantId, qty: remaining, crossSellItemId: u.crossSellItemId, properties: u.properties || null });
      }

      if (desired === 0 && lines.length) {
        lines.forEach(function (line) { updates.push({ type: 'line', key: line.key, qty: 0 }); });
      }
    });

    return updates;
  }

  function applyUpdates(updates) {
    var lineEntries = updates.filter(function (u) { return u.type === 'line'; });
    var addEntries = updates.filter(function (u) { return u.type === 'add'; });

    var p = Promise.resolve();

    if (lineEntries.length) {
      var fd = new FormData();
      lineEntries.forEach(function (u) { fd.append('updates[' + u.key + ']', String(u.qty)); });
      p = p.then(function () { return fetch('/cart/update.js', { method: 'POST', body: fd, credentials: 'same-origin' }); });
    }

    addEntries.forEach(function (u) {
      p = p.then(function () {
        var baseProps = {
          _cross_sell: 'true'
        };
        if (u.properties) {
          for (var k in u.properties) {
            if (Object.prototype.hasOwnProperty.call(u.properties, k)) {
              baseProps[k] = String(u.properties[k]);
            }
          }
        }
        var body = {
          id: Number(u.variantId),
          quantity: u.qty,
          properties: baseProps
        };
        
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'content-type': 'application/json' },
          credentials: 'same-origin',
          body: JSON.stringify(body)
        });
      });
    });

    // Alleen na add of decrease (niet bij pure increase of no-op)
    var hadAdd = addEntries.length > 0;
    var hadDecrease = lineEntries.some(function (u) { return (u.prevQty || 0) > u.qty; });
    if (hadAdd || hadDecrease) {
      p = p.then(function(){ return getCart(); })
        .then(function(cart){
          try {
            var evt = new CustomEvent('cart:update', { bubbles: true, detail: { resource: cart, sourceId: 'mixed-offer', data: { itemCount: cart.item_count } } });
            document.dispatchEvent(evt);
            window.dispatchEvent(evt);
            disableCrossSellQuantity(cart);
          } catch(e) {}
        });
    }

    return p;
  }

  // Een regel telt als "trigger-kandidaat" als het GEEN cross-sell regel is (bijv. verf).
  // Nodig zodat auto-add cadeaus ook berekend worden wanneer er nog geen cross-sell in de mand zit.
  function isCrossSellItemLine(item) {
    if (!item || !item.properties) return false;
    var p = item.properties;
    if (String(p._cross_sell || '').toLowerCase() === 'true') return true;
    return ['_is_free', '_max_quantity', '_discount_type', '_quantity_rule_type', '_quantity_rule_config'].some(function (k) {
      return p[k] !== undefined && p[k] !== null && String(p[k]).trim() !== '';
    });
  }

  var recompute = debounce(function () {
    if (isApplying) return;
    getCart()
      .then(function (cart) {
        var needsEnforcement = Array.isArray(cart && cart.items) && cart.items.some(shouldLockItem);
        // Ook berekenen zodra er een trigger-kandidaat (niet-cross-sell product) in de mand ligt,
        // zodat auto-add cadeaus uit het niets kunnen worden toegevoegd.
        var hasTriggerCandidate = Array.isArray(cart && cart.items) && cart.items.some(function (i) { return !isCrossSellItemLine(i); });
        var shouldCompute = needsEnforcement || hasTriggerCandidate;
        if (!needsEnforcement) {
          disableCrossSellQuantity(cart);
        }
        return Promise.all([
          Promise.resolve(cart),
          shouldCompute ? compute(itemsForCompute(cart)) : Promise.resolve({ updates: [] })
        ]);
      })
      .then(function (tuple) {
        var cart = tuple[0];
        var plan = tuple[1] || { updates: [] };
        var hash = JSON.stringify(plan.updates || []);
        if (hash === lastHash) {
          disableCrossSellQuantity(cart);
          return;
        }
        lastHash = hash;
        var updates = planToLineUpdates(cart, plan);
        if (!updates.length) {
          disableCrossSellQuantity(cart);
          return;
        }
        isApplying = true;
        return applyUpdates(updates).finally(function () {
          isApplying = false;
        });
      })
      .finally(function () { isApplying = false; });
  }, 400);

  var LOCK_ATTR = 'data-cross-sell-lock';
  var CONTROL_ATTR = 'data-cross-sell-lock-applied';

  function shouldLockItem(item){
    if (!item || !item.properties) return false;
    var props = item.properties;
    var explicitCrossSellFlag = String(props._cross_sell || '').toLowerCase() === 'true';
    var hasCrossSellIndicators = ['_cross_sell', '_is_free', '_max_quantity', '_discount_type', '_quantity_rule_type', '_quantity_rule_config'].some(function(key){
      return props[key] !== undefined && props[key] !== null && String(props[key]).trim() !== '';
    });
    var isCrossSell = explicitCrossSellFlag || hasCrossSellIndicators;
    if (!isCrossSell) return false;
    var isZeroPriced = Number(item.final_line_price || item.final_price || item.price) === 0;
    var isFree = isZeroPriced || String(props._is_free || '').toLowerCase() === 'true';
    var hasMax = props._max_quantity !== undefined && props._max_quantity !== null && String(props._max_quantity).trim() !== '';
    var ruleType = String(props._quantity_rule_type || '').trim();
    var hasRule = ruleType !== '';
    return isFree || hasMax || hasRule;
  }

  function toggleControlDisabled(control, shouldDisable){
    if (!control) return;
    if (shouldDisable) {
      if (!control.getAttribute(CONTROL_ATTR)) {
        control.setAttribute(CONTROL_ATTR, 'true');
      }
      control.disabled = true;
      control.setAttribute('disabled','');
    } else if (control.getAttribute(CONTROL_ATTR) === 'true') {
      control.disabled = false;
      control.removeAttribute(CONTROL_ATTR);
      control.removeAttribute('disabled');
    }
  }

  function applyLockState(row, shouldLock){
    if (!row) return;
    try { row.setAttribute(LOCK_ATTR, shouldLock ? 'true' : 'false'); } catch(e) {}
    try {
      if (shouldLock) {
        row.setAttribute('data-cross-sell', 'true');
      } else {
        row.removeAttribute('data-cross-sell');
      }
    } catch(e) {}
    var qs = row.querySelector('.quantity-selector');
    var input = row.querySelector('input[name="updates[]"]');
    var minus = row.querySelector('.quantity-minus');
    var plus = row.querySelector('.quantity-plus');

    toggleControlDisabled(input, shouldLock);
    toggleControlDisabled(minus, shouldLock);
    toggleControlDisabled(plus, shouldLock);

    if (qs) {
      if (shouldLock) {
        qs.setAttribute(CONTROL_ATTR, 'true');
        qs.setAttribute('aria-disabled','true');
        qs.setAttribute('disabled','');
        qs.style.pointerEvents = 'none';
        qs.style.opacity = '.4';
      } else if (qs.getAttribute(CONTROL_ATTR) === 'true') {
        qs.removeAttribute(CONTROL_ATTR);
        qs.removeAttribute('disabled');
        qs.setAttribute('aria-disabled','false');
        qs.style.pointerEvents = '';
        qs.style.opacity = '';
      }
    }
  }

  function disableCrossSellQuantity(cart){
    try { window.__MIXED_OFFER_LAST_CART__ = cart; } catch(e) {}
    if (!cart || !Array.isArray(cart.items) || cart.items.length === 0) {
      return;
    }

    (cart.items || []).forEach(function(item){
      var selector = '[data-key="' + item.key + '"]';
      var row = document.querySelector(selector);
      if (!row) return;

      var lock = shouldLockItem(item);
      applyLockState(row, lock);

      if (lock) {
        setTimeout(function(){
          var verifyRow = document.querySelector(selector);
          if (!verifyRow) return;
          applyLockState(verifyRow, true);
        }, 100);
      }
    });
  }

  // Hard block interacties op cross-sell quantity (fallback tegen re-render enabling)
  function isLockedCrossSellRow(el){
    try {
      var row = el && el.closest && el.closest('tr[data-key]');
      if(!row) return false;
      return row.getAttribute(LOCK_ATTR) === 'true';
    } catch(e) { return false; }
  }

  document.addEventListener('click', function(e){
    var t = e.target;
    if(!t) return;
    if (t.closest && (t.closest('.quantity-minus') || t.closest('.quantity-plus'))) {
      if (isLockedCrossSellRow(t)) {
        e.stopImmediatePropagation();
        e.preventDefault();
      }
    }
  }, true);

  document.addEventListener('input', function(e){
    var t = e.target;
    if(!t || t.name !== 'updates[]') return;
    if (isLockedCrossSellRow(t)) {
      e.stopImmediatePropagation();
      e.preventDefault();
      try { t.value = t.getAttribute('value') || String(t.value); } catch(err) {}
    }
  }, true);

  // Observe cart containers om na (re)render opnieuw te locken
  try {
    var cartObserver = new MutationObserver(function(){
      var cart = window.__MIXED_OFFER_LAST_CART__;
      if (cart && cart.items && cart.items.length) {
        disableCrossSellQuantity(cart);
      }
    });
    var attachObserver = function(){
      var containers = document.querySelectorAll('.cart-items__wrapper, .cart-drawer__content, main[role="main"]');
      containers.forEach(function(c){
        try { cartObserver.observe(c, { subtree: true, childList: true }); } catch(e) {}
      });
    };
    attachObserver();
    document.addEventListener('shopify:section:load', attachObserver);
  } catch(e) {}

  // Alleen luisteren op cart:update (thema-event)
  var onCartUpdate = function (e) {
    var sourceId = e && e.detail && e.detail.sourceId;
    var doLocks = function(cart){
      try {
        disableCrossSellQuantity(cart);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 100);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 300);
      } catch(err) {}
    };
    try{
      var payloadCart = e && e.detail && e.detail.resource;
      if (payloadCart && Array.isArray(payloadCart.items) && payloadCart.items.length > 0) {
        doLocks(payloadCart);
      } else {
        // Fallback: haal actuele cart op als payload leeg is (bijv. header event)
        getCart().then(function(cart){ doLocks(cart); });
      }
    }catch(err){}
    if (sourceId === 'mixed-offer') {
      return;
    }
    recompute();
  };
  document.addEventListener('cart:update', onCartUpdate);
  window.addEventListener('cart:update', onCartUpdate);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      getCart().then(function(cart){
        disableCrossSellQuantity(cart);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 100);
        setTimeout(function(){ disableCrossSellQuantity(cart); }, 300);
      });
      setTimeout(recompute, 0);
    });
  } else {
    getCart().then(function(cart){
      disableCrossSellQuantity(cart);
      setTimeout(function(){ disableCrossSellQuantity(cart); }, 100);
      setTimeout(function(){ disableCrossSellQuantity(cart); }, 300);
    });
    setTimeout(recompute, 0);
  }

  // Geen extra hooks; enkel theme-event en eerste run

  // Expose voor snelle diagnose in console
  try { window.__MIXED_OFFER_RECOMPUTE__ = recompute; } catch(e) {}
})();


